import { MayBeNull, UserDetails } from '@wpp-open/core'

import { UpdateGroupsUsersPayload } from 'api/groups/fetchers/updateGroupsUsersApi'

export enum GroupType {
  System = 'SYSTEM',
}
export interface TenantGroup {
  id: string
  name: string
  description: string
  customData: MayBeNull<Record<string, any>>
  createdOnAccountId: string
  uniqueRolesCount: number
  uniqueUsersCount: number
  isDeleted?: boolean
  type: MayBeNull<GroupType>
}

export interface AzGroup {
  uid: string
  account_uid: string
  name: string
  description: string
  custom_data: MayBeNull<Record<string, any>>
}

export interface AzV2Group {
  uid?: string
  id: string
  createdOnAccountId: string
  name: string
  description: string
  customData: MayBeNull<Record<string, any>>
  type: MayBeNull<GroupType>
}

export interface GroupForm {
  name: string
  description: string
  account_uid: string
  members?: Pick<UserDetails, 'firstname' | 'lastname' | 'email'>[]
}

export interface GroupFormCreateDTO {
  account_uid: string
  name: string
  description: string
  custom_data: {}
}

export interface GroupFormEditDTO {
  name: string
  description: string
}

export interface GroupFormEditData {
  group: GroupFormEditDTO
  members: UpdateGroupsUsersPayload
}

export interface GroupUser {
  email: string
  group_id: string
  group_name: string
  username: string
  first_name: MayBeNull<string>
  id: string
  last_name: MayBeNull<string>
  updated_at: string
  created_at: string
  isExternal?: boolean
  synced?: boolean
}

export interface GroupRole {
  created_at: string
  available_only_in_account_name: string
  name: string
  description: string
  uid: string
  code: string
  is_inheritable: boolean
  updated_at: string
  available_only_in_account_id: string
}
